import React from "react";
import "./Banner.css";

const Banner = () => {
  return (
    <div
      id="carouselExampleCaptions"
      className="carousel slide"
      data-bs-ride="carousel"
    >
      <div className="carousel-indicators">
        <button
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide-to="0"
          className="active"
          aria-current="true"
          aria-label="Slide 1"
        ></button>
        <button
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide-to="1"
          aria-label="Slide 2"
        ></button>
        <button
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide-to="2"
          aria-label="Slide 3"
        ></button>
      </div>
      <div className="carousel-inner">
        <div className="carousel-item active">
          <img
            src="https://i.ibb.co/QMqxSc0/pexels-shiny-diamond-3373746.jpg"
            className="d-block w-100"
            alt="..."
          />
          <div className="carousel-caption d-none d-md-block">
            <h4 className="fw-bold">MAKE LIFE COLOURFUL</h4>
            <h5 className="fw-bold">The brightest and most vibrant colours</h5>
          </div>
        </div>
        <div className="carousel-item">
          <img
            src="https://i.ibb.co/WVJZD1J/pexels-shiny-diamond-3373741.jpg"
            className="d-block w-100"
            alt="..."
          />
          <div className="carousel-caption d-none d-md-block">
            <h4 className="fw-bold">MAKE LIFE COLOURFUL</h4>
            <h5 className="fw-bold">The brightest and most vibrant colours</h5>
          </div>
        </div>
        <div className="carousel-item">
          <img
            src="https://i.ibb.co/wzM7Pnt/pexels-ron-lach-8128699.jpg"
            className="d-block w-100"
            alt="..."
          />
          <div className="carousel-caption d-none d-md-block">
            <h4 className="fw-bold">MAKE LIFE COLOURFUL</h4>
            <h5 className="fw-bold">The brightest and most vibrant colours</h5>
          </div>
        </div>
      </div>
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#carouselExampleCaptions"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#carouselExampleCaptions"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
};

export default Banner;
